<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Kasir" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li
                  v-for="tab in upperTabsLab"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="`nav-link ${tab.active ? 'active' : ''}`"
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="item.filter == status"
                  />
                </b-tabs>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              v-if="loaded"
              :columns="columns"
              :per-page="parseInt(perPage)"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
            ></datatable>
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ countTotalRows }} data dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { data, tabsStatus, filters, sort, upperTabsLab } from "@/data/Kasir.js";
import { toCapitalize, getInputDate } from "@/data/helper.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "KasirLab",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      toCapitalize: toCapitalize,
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabsStatus,
      upperTabsLab: upperTabsLab,
      created_from: getInputDate(),
      created_to: getInputDate(),
      orderBy: "desc",
      status: "",
      columns: [
        {
          label: "No",
          field: "number",
        },
        { label: "No Rawat", field: "no_rawat" },
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "nama" },
        { label: "Lab", field: "periksa_lab" },
        { label: "Total Bayar", field: "total_bayar" },
        { label: "Sisa Bayar", field: "sisa_tagihan" },
        { label: "Status", field: "status" },
        {
          label: "",
          class: "dropdown",
          representedAs: (
            item
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/kasir/form/lab/${item["id_tagihan_ringkasan"]}/rincian?fromTab=${item.fromTab}""><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/kasir/form/lab/${item["id_tagihan_ringkasan"]}/rincian?fromTab=${item.fromTab}"">
                        <i class="material-symbols-outlined">open_in_new</i>
                        Detail Pembayaran
                    </a>
                    <a class="dropdown-item" href="/#/kasir/form/lab/${item["id_tagihan_ringkasan"]}/riwayat?fromTab=${item.fromTab}"" >
                        <i class="material-symbols-outlined">history</i>
                        Riwayat Pembayaran
                    </a>
                    <a class="dropdown-item" href="/#/kasir/invoice/lab/${item["id_tagihan_ringkasan"]}/rincian?fromTab=${item.fromTab}"" target="_blank" >
                        <i class="material-symbols-outlined">print</i>
                        Cetak Invoice
                    </a>
                </div>`,
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    countRows() {
      let that = this;
      setInterval(function() {
        let count = document.querySelectorAll(
          ".table-responsive table.responsive tbody>tr"
        ).length;
        if (that.countTotalRows != count) {
          that.countTotalRows = count;
        }
      }, 1000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["status"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      // updated from and created to filter
      if (this.created_from) {
        params += `&updated_from=${this.created_from}`;
      } else {
        params += `&updated_from=null`;
      }
      if (this.created_to) {
        params += `&updated_to=${this.created_to}`;
      } else {
        params += `&updated_to=null`;
      }
      // updated from and created to filter
      if (this["status"]) {
        params += `&status=${this.status}`;
      }
      try {
        let result = await this.$store.state.HTTP.get(
          "menu/kasir/rawat_periksa_lab" + params
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          let self = this;
          this.rows = result.data.map((item, index) => {
            item.number = index + 1;
            item.fromTab = self.status;
            return item;
          });
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.countRows();
    if (this.$route.query.tab) {
      this.status = this.toCapitalize(this.$route.query.tab);
      ////console.log(this.status);
    }
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
